"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[77423],{

/***/ 82034:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95934);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_styleHelper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54540);
/* harmony import */ var _styles_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2080);




var H3 = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("h3", {
    target: "e1121ic30",
    label: "H3"
})("font-weight:", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .Fonts.BOLD */ .F3.Pl, ";font-size:", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .Fonts.H3 */ .F3.H3, ";line-height:", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .Fonts.PARA_LINE_HEIGHT */ .F3.MA, ";color:", function(param) {
    var color = param.color;
    return color;
}, ";margin:", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .Spacings.SPACING_0B */ .t8.NE, ";@media only screen and (max-width:", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .breakpoints.tablet */ .AV.tablet, "){font-size:24px;}@media only screen and (max-width:", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .breakpoints.mobile */ .AV.mobile, "){font-size:22px;}", function(param) {
    var lineClamp = param.lineClamp;
    return lineClamp ? _utils_styleHelper__WEBPACK_IMPORTED_MODULE_1__/* ["default"].lineClampStyle */ .Z.lineClampStyle(lineClamp) : null;
});
/* harmony default export */ __webpack_exports__["Z"] = (H3);
H3.propTypes = {
    color: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
    lineClamp: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().number)
};
H3.defaultProps = {
    color: "var(--color-text-primary)",
    lineClamp: null
};


/***/ }),

/***/ 52236:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95934);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _styles_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2080);



var getStyling = function(type) {
    var styling = {
        filled: {
            Bg: "var(--color-base-fill)",
            Text: "var(--color-base-1)",
            paddingHorizontal: _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Spacings.SPACING_2B */ .t8.Rw,
            fontSize: _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Fonts.H7 */ .F3.H7
        },
        hollow: {
            Bg: "var(--color-shadow)",
            Text: "var(--color-text-primary)",
            paddingHorizontal: _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Spacings.SPACING_6 */ .t8.A1,
            fontSize: _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Fonts.EXTRA_SMALL */ .F3.y2
        },
        transparent: {
            Bg: "var(--color-base-1)",
            Text: "var(--color-i-blue)",
            paddingHorizontal: _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Spacings.SPACING_0B */ .t8.NE,
            fontSize: _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Fonts.H7 */ .F3.H7
        },
        live: {
            Bg: "var(--color-i-red)",
            Text: "var(--color-i-white)",
            paddingHorizontal: _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Spacings.SPACING_2B */ .t8.Rw,
            fontSize: _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Fonts.H7 */ .F3.H7
        },
        disabled: {
            Bg: "var(--color-base-1)",
            Text: "var(--color-text-secondary)",
            paddingHorizontal: _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Spacings.SPACING_0B */ .t8.NE,
            fontSize: _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Fonts.EXTRA_SMALL */ .F3.y2
        },
        discount: {
            Bg: "var(--color-i-orange-16)",
            Text: "var(--color-i-orange-1)",
            paddingHorizontal: _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Spacings.SPACING_2B */ .t8.Rw,
            fontSize: _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Fonts.H7 */ .F3.H7
        },
        alert: {
            Bg: "var(--color-base-1)",
            Text: "var(--color-i-red)",
            paddingHorizontal: _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Spacings.SPACING_0B */ .t8.NE,
            fontSize: _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Fonts.H7 */ .F3.H7
        },
        success: {
            Bg: "var(--color-i-green)",
            Text: "var(--color-base-1)",
            paddingHorizontal: "10px",
            fontSize: _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Fonts.EXTRA_SMALL */ .F3.y2
        }
    };
    return styling[type];
};
var semiBold = [
    "filled",
    "live",
    "alert"
];
var Tags = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("span", {
    target: "e13dpfl00",
    label: "Tags"
})("background-color:", function(param) {
    var type = param.type, bgColor = param.bgColor;
    var ref;
    return bgColor || ((ref = getStyling(type)) === null || ref === void 0 ? void 0 : ref.Bg);
}, ";color:", function(param) {
    var type = param.type;
    var ref;
    return (ref = getStyling(type)) === null || ref === void 0 ? void 0 : ref.Text;
}, ";font-size:", function(param) {
    var type = param.type;
    return getStyling(type).fontSize;
}, ";font-weight:", function(param) {
    var type = param.type;
    return semiBold.includes(type) ? _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Fonts.SEMIBOLD */ .F3.rX : _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Fonts.BOLD */ .F3.Pl;
}, ";padding:", function(param) {
    var type = param.type;
    var ref;
    return "".concat(_styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Spacings.SPACING_6 */ .t8.A1, " ").concat((ref = getStyling(type)) === null || ref === void 0 ? void 0 : ref.paddingHorizontal);
}, ";border-radius:", _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Spacings.SPACING_1B */ .t8.MK, ";display:inline-block;text-transform:uppercase;line-height:1;");
/* harmony default export */ __webpack_exports__["Z"] = (Tags);
Tags.propTypes = {
    type: prop_types__WEBPACK_IMPORTED_MODULE_2___default().oneOf([
        "filled",
        "hollow",
        "transparent",
        "live",
        "disabled",
        "discount",
        "alert",
        "success"
    ]),
    bgColor: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string)
};
Tags.defaultProps = {
    type: "transparent",
    bgColor: null
};


/***/ }),

/***/ 42058:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ PlatFormBatchCard; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(95934);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./src/components/Base/Thumbnail/Thumbnail.tsx
var Thumbnail = __webpack_require__(75591);
// EXTERNAL MODULE: ./src/components/Base/Link/Link.jsx
var Link = __webpack_require__(76356);
// EXTERNAL MODULE: ./src/components/Base/Divider/Divider.jsx
var Divider = __webpack_require__(46736);
// EXTERNAL MODULE: ./src/components/Base/H6/H6.jsx
var H6 = __webpack_require__(10076);
// EXTERNAL MODULE: ./src/models/BatchGroup.js
var BatchGroup = __webpack_require__(20211);
// EXTERNAL MODULE: ./src/styleConstants/index.js
var styleConstants = __webpack_require__(2080);
// EXTERNAL MODULE: ./src/components/Base/Button/Button.jsx
var Button = __webpack_require__(35415);
// EXTERNAL MODULE: ./src/hooks/usePlatformBatchEventProps.js
var usePlatformBatchEventProps = __webpack_require__(60722);
// EXTERNAL MODULE: ./src/constants/segment.js
var segment = __webpack_require__(17579);
// EXTERNAL MODULE: ./src/redux/actions/analytics.js
var analytics = __webpack_require__(87936);
// EXTERNAL MODULE: ./src/components/Base/H5/H5.jsx
var H5 = __webpack_require__(43807);
// EXTERNAL MODULE: ./src/components/Container/BatchGroup/utils.js
var utils = __webpack_require__(65840);
// EXTERNAL MODULE: ./src/components/Container/BatchGroup/BatchGroupCardInfo.jsx
var BatchGroupCardInfo = __webpack_require__(95201);
// EXTERNAL MODULE: ./src/components/Container/BatchGroup/BatchGroupTags.jsx
var BatchGroupTags = __webpack_require__(35202);
// EXTERNAL MODULE: ./src/components/Container/BatchGroup/constants/index.js
var constants = __webpack_require__(10736);
// EXTERNAL MODULE: ./src/components/Base/Image.jsx
var Image = __webpack_require__(80867);
// EXTERNAL MODULE: ./src/components/Base/H7/H7.jsx
var H7 = __webpack_require__(28197);
// EXTERNAL MODULE: ./src/stores/useDarkModeStatus.js
var useDarkModeStatus = __webpack_require__(3458);
// EXTERNAL MODULE: ./src/stores/selectors/darkModeStatusSelectors.js
var darkModeStatusSelectors = __webpack_require__(57054);
;// CONCATENATED MODULE: ./src/components/Container/BatchGroup/BatchGroupCard/BatchCardFooter.jsx








var Container = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e139c3z0",
    label: "Container"
})("display:flex;justify-content:center;align-items:center;background-color:", function(param) {
    var $color = param.$color;
    return $color;
}, ";padding:", styleConstants/* Spacings.SPACING_10 */.t8.$z, " ", styleConstants/* Spacings.SPACING_0B */.t8.NE, ";text-align:center;width:100%;border-radius:", styleConstants/* Spacings.SPACING_1B */.t8.MK, ";min-height:", styleConstants/* Spacings.SPACING_8B */.t8.B3, ";margin:", styleConstants/* Spacings.SPACING_4B */.t8.BM, " auto ", styleConstants/* Spacings.SPACING_0B */.t8.NE, ";h6{margin-left:", styleConstants/* Spacings.SPACING_1B */.t8.MK, ";}");
var BottomText = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(H7/* default */.Z, {
    target: "e139c3z1",
    label: "BottomText"
})();
var BatchCardFooter = function(param) {
    var isFeedCard = param.isFeedCard, stateMetaInfo = param.stateMetaInfo;
    var isDarkModeOn = (0,useDarkModeStatus/* default */.Z)(darkModeStatusSelectors/* getIsDarkModeOn */.q1);
    var ctaState = (0,utils/* getCtaState */.gP)(stateMetaInfo, isDarkModeOn);
    if (!ctaState) return null;
    var icon = ctaState.icon, text = ctaState.text, buttonColor = ctaState.buttonColor, textColor = ctaState.textColor;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Container, {
        $isFeedCard: isFeedCard,
        $color: buttonColor,
        children: [
            icon && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image["default"], {
                src: icon,
                alt: "icon",
                width: 16,
                height: 16
            }),
            text && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BottomText, {
                color: textColor,
                children: text
            })
        ]
    });
};
/* harmony default export */ var BatchGroupCard_BatchCardFooter = (BatchCardFooter);

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/Composite/CourseCard/index.js + 1 modules
var CourseCard = __webpack_require__(87414);
;// CONCATENATED MODULE: ./src/components/Composite/BatchCard/PlatFormBatchCard.jsx





















var CourseThumbnail = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(Thumbnail/* default */.Z, {
    target: "eiiqvea0",
    label: "CourseThumbnail"
})("border-top-left-radius:", styleConstants/* Spacings.SPACING_2B */.t8.Rw, ";border-top-right-radius:", styleConstants/* Spacings.SPACING_2B */.t8.Rw, ";", styleConstants/* mediaQuery.uptoTablet */.cy.uptoTablet, "{width:100%;height:190px;}");
var CardContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(CourseCard/* Container */.W2, {
    target: "eiiqvea1",
    label: "CardContainer"
})("position:relative;width:", function(param) {
    var _$cardType = param.$cardType, $cardType = _$cardType === void 0 ? constants/* cardType.MEDIUM */.Iw.MEDIUM : _$cardType;
    return constants/* cardWidth */.p7[$cardType].web;
}, ";margin-bottom:", styleConstants/* Spacings.SPACING_8B */.t8.B3, ";background:var(--color-base-1);padding-bottom:", styleConstants/* Spacings.SPACING_0B */.t8.NE, ";display:flex;flex-direction:column;.batch-thumbnail{width:100%;height:190px;}", styleConstants/* mediaQuery.uptoMobile */.cy.uptoMobile, "{width:", function(param) {
    var _$cardType = param.$cardType, $cardType = _$cardType === void 0 ? constants/* cardType.SMALL */.Iw.SMALL : _$cardType;
    return constants/* cardWidth */.p7[$cardType].mobile;
}, ";margin-bottom:", styleConstants/* Spacings.SPACING_0B */.t8.NE, ";padding-bottom:", styleConstants/* Spacings.SPACING_2B */.t8.Rw, ";.batch-thumbnail{width:100%;height:150px;}}");
var Content = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "eiiqvea2",
    label: "Content"
})("padding:", styleConstants/* Spacings.SPACING_4B */.t8.BM, ";", styleConstants/* mediaQuery.uptoTablet */.cy.uptoTablet, "{margin-bottom:0;}");
var CourseTitle = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(H6/* default */.Z, {
    target: "eiiqvea3",
    label: "CourseTitle"
})("margin-top:", styleConstants/* Spacings.SPACING_1B */.t8.MK, ";margin-bottom:", styleConstants/* Spacings.SPACING_4B */.t8.BM, ";color:var(--color-text-primary);font-size:", function(param) {
    var $isFeedCard = param.$isFeedCard;
    return $isFeedCard ? styleConstants/* Fonts.LARGE */.F3.ln : styleConstants/* Fonts.SMALL */.F3.HC;
}, ";", styleConstants/* mediaQuery.uptoTablet */.cy.uptoTablet, "{font-size:", styleConstants/* Fonts.LARGE */.F3.ln, ";}");
var StyledDivider = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(Divider/* default */.Z, {
    target: "eiiqvea4",
    label: "StyledDivider"
})("margin:", styleConstants/* Spacings.SPACING_0B */.t8.NE, " auto ", styleConstants/* Spacings.SPACING_3B */.t8.N, " auto;width:100%;");
var CardFooter = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "eiiqvea5",
    label: "CardFooter"
})("width:100%;margin-top:auto;padding:", styleConstants/* Spacings.SPACING_4B */.t8.BM, ";");
var PriceText = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(H6/* default */.Z, {
    target: "eiiqvea6",
    label: "PriceText"
})("font-weight:", styleConstants/* Fonts.REGULAR */.F3.iD, ";font-size:", styleConstants/* Spacings.SPACING_3B */.t8.N, ";color:", function(param) {
    var $color = param.$color;
    return $color;
}, ";");
var SlashPriceMessage = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(PriceText, {
    target: "eiiqvea7",
    label: "SlashPriceMessage"
})();
var PriceCardSection = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "eiiqvea8",
    label: "PriceCardSection"
})("width:100%;display:flex;justify-content:space-between;align-items:center;");
var CoursePriceAndTime = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "eiiqvea9",
    label: "CoursePriceAndTime"
})();
var ViewDetails = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(Button/* default */.Z, {
    target: "eiiqvea10",
    label: "ViewDetails"
})("background-color:", function(param) {
    var $secondary = param.$secondary;
    return $secondary ? "unset" : "var(--color-base-fill)";
}, ";color:", function(param) {
    var $secondary = param.$secondary;
    return $secondary ? "unset" : "var(--color-text-tertiary)";
}, ";width:", function(param) {
    var $isFeedCard = param.$isFeedCard;
    return $isFeedCard ? "100px" : "120px";
}, ";height:36px;min-height:36px;font-size:", styleConstants/* Fonts.ULTRA_SMALL */.F3.tN, ";font-weight:", styleConstants/* Fonts.HEAVY */.F3.XR, ";&:active{background-color:", function(param) {
    var $secondary = param.$secondary;
    return $secondary ? "unset" : "var(--color-i-black)";
}, ";}");
var PriceValue = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(H5/* default */.Z, {
    target: "eiiqvea11",
    label: "PriceValue"
})("margin-left:", function(param) {
    var $isSlashPriceAvailable = param.$isSlashPriceAvailable;
    return $isSlashPriceAvailable ? styleConstants/* Spacings.SPACING_2B */.t8.Rw : styleConstants/* Spacings.SPACING_0B */.t8.NE;
}, ";font-size:", function(param) {
    var _$fontSize = param.$fontSize, $fontSize = _$fontSize === void 0 ? styleConstants/* Fonts.LARGE */.F3.ln : _$fontSize;
    return $fontSize;
}, ";color:", function(param) {
    var $color = param.$color;
    return $color;
}, ";");
var SlashPrice = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(PriceValue, {
    target: "eiiqvea12",
    label: "SlashPrice"
})("text-decoration-line:line-through;color:var(--color-text-secondary);font-weight:", styleConstants/* Fonts.LIGHT */.F3.rp, ";font-size:", function(param) {
    var $fontSize = param.$fontSize;
    return $fontSize;
}, ";");
var PriceWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "eiiqvea13",
    label: "PriceWrapper"
})("display:flex;");
var StyledLink = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(Link/* default */.Z, {
    target: "eiiqvea14",
    label: "StyledLink"
})("display:flex;flex-direction:column;height:100%;");
var BatchInfoWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "eiiqvea15",
    label: "BatchInfoWrapper"
})("opacity:", function(param) {
    var $hasOpacity = param.$hasOpacity;
    return $hasOpacity ? 0.7 : 1;
}, ";");
var PlatformBatchCard = function(param) {
    var gridColumn = param.gridColumn, className = param.className, batch = param.batch, orientation = param.orientation, dataAnalytics = param.dataAnalytics, isFeedCard = param.isFeedCard, lastPrimarySourceSection = param.lastPrimarySourceSection, platformCardType = param.cardType;
    var languages = batch.languages, isEnrolled = batch.isEnrolled, enrollmentEndDate = batch.enrollmentEndDate, price = batch.price, name = batch.name, isDiscountAvailable = batch.isDiscountAvailable, discountEndDate = batch.discountEndDate, listPrice = batch.listPrice, promoText = batch.promoText, completedAt = batch.completedAt, classType = batch.classType, stateMetaInfo = batch.stateMetaInfo;
    var entitySubType = (0,react.useMemo)(function() {
        return (0,utils/* getEntitySubType */.ri)(batch === null || batch === void 0 ? void 0 : batch.classType);
    }, [
        batch === null || batch === void 0 ? void 0 : batch.classType
    ]);
    var segmentData = (0,usePlatformBatchEventProps/* default */.Z)({
        batch: batch,
        entityContentType: true,
        lastPrimarySourceSection: lastPrimarySourceSection,
        isBatch: true,
        isSlashedPriceType: true,
        extraProps: {
            price: price,
            entity_sub_type: entitySubType
        }
    });
    if (!batch) return null;
    var handleAnalytics = function() {
        analytics/* segment.track */.EX.track(segment/* PLATFORM_BATCH_CARD_CLICKED */.vxe, segmentData);
    };
    var thumbnailUrl = batch.thumbnail || batch.coverPhoto;
    var ref;
    var isBatchAccessEnded = (ref = batch === null || batch === void 0 ? void 0 : batch.isAccessEnded) !== null && ref !== void 0 ? ref : false;
    var isBatchCompleted = (0,utils/* getIsBatchCompleted */.aw)(completedAt);
    var slashPriceMessage = (0,utils/* getSlashPriceMessage */.Y3)(discountEndDate, promoText, isDiscountAvailable, isBatchCompleted);
    var fontSizeForPrice = (0,utils/* getFontSizeForPrice */.d)(price, listPrice, isDiscountAvailable);
    var isEnrollmentClose = (0,utils/* getIsEnrollmentClosed */.wR)(enrollmentEndDate);
    var languagesForCard = (0,utils/* getLanguagesForCard */.yu)(languages);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardContainer, {
        $cardType: platformCardType,
        className: className,
        gridColumn: gridColumn,
        orientation: orientation,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledLink, {
            href: BatchGroup/* LinkPath */.CO,
            as: (0,BatchGroup/* getLink */.Rg)(batch),
            onClick: handleAnalytics,
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CourseThumbnail, {
                    imgUrl: thumbnailUrl,
                    orientation: orientation,
                    "data-analytics": "".concat(dataAnalytics, "Card")
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Content, {
                    $isFeedCard: isFeedCard,
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BatchGroupTags/* default */.Z, {
                            languages: languagesForCard,
                            classType: classType
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(BatchInfoWrapper, {
                            $hasOpacity: isBatchAccessEnded,
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CourseTitle, {
                                    lineClamp: 2,
                                    as: "h4",
                                    $isFeedCard: isFeedCard,
                                    children: name
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BatchGroupCardInfo/* default */.Z, {
                                    showDifferentIconOnDarkMode: true,
                                    batch: batch
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CardFooter, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledDivider, {}),
                        !isEnrolled && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PriceCardSection, {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CoursePriceAndTime, {
                                    children: [
                                        slashPriceMessage ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SlashPriceMessage, {
                                            children: slashPriceMessage
                                        }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PriceText, {
                                            $color: isEnrollmentClose ? "var(--color-text-secondary)" : "var(--color-text-primary)",
                                            children: "Price"
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PriceWrapper, {
                                            children: [
                                                isDiscountAvailable && listPrice && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SlashPrice, {
                                                    $fontSize: fontSizeForPrice,
                                                    children: [
                                                        "\u20B9",
                                                        listPrice
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PriceValue, {
                                                    $isSlashPriceAvailable: isDiscountAvailable && listPrice,
                                                    $fontSize: fontSizeForPrice,
                                                    $color: isEnrollmentClose ? "var(--color-text-secondary)" : "var(--color-text-primary)",
                                                    children: [
                                                        "\u20B9",
                                                        price
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ViewDetails, {
                                    $secondary: isEnrollmentClose,
                                    $isFeedCard: isFeedCard,
                                    variant: isEnrollmentClose ? "hollow" : "filled",
                                    label: "View details"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BatchGroupCard_BatchCardFooter, {
                            isFeedCard: isFeedCard,
                            stateMetaInfo: stateMetaInfo
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var PlatFormBatchCard = (PlatformBatchCard);
PlatformBatchCard.propTypes = {
    gridColumn: (prop_types_default()).string,
    className: (prop_types_default()).string,
    orientation: prop_types_default().oneOf([
        "horizontal",
        "vertical"
    ]),
    batch: prop_types_default().objectOf((prop_types_default()).any).isRequired,
    dataAnalytics: (prop_types_default()).string,
    isFeedCard: (prop_types_default()).bool,
    cardType: (prop_types_default()).string
};
PlatformBatchCard.defaultProps = {
    gridColumn: "span 6",
    className: "",
    orientation: "vertical",
    dataAnalytics: "",
    isFeedCard: false,
    cardType: constants/* cardType.MEDIUM */.Iw.MEDIUM
};


/***/ }),

/***/ 26572:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GA": function() { return /* binding */ UpcomingBatchEmptyState; },
/* harmony export */   "Gt": function() { return /* binding */ BatchesEmptyState; },
/* harmony export */   "iP": function() { return /* binding */ emptyUpcomingStateConfig; }
/* harmony export */ });
/* unused harmony export Container */
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35944);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95934);
/* harmony import */ var _styles_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2080);
/* harmony import */ var _utils_imageHelper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48821);
/* harmony import */ var _EmptyState__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85081);





var emptyStateConfig = {
    image: (0,_utils_imageHelper__WEBPACK_IMPORTED_MODULE_2__/* .getImage */ .gJ)("noUpcomingBatches.svg"),
    title: "No batches found",
    description: "Upcoming batches will show up here"
};
var emptyBatchStateConfigOnEducator = {
    image: (0,_utils_imageHelper__WEBPACK_IMPORTED_MODULE_2__/* .getImage */ .gJ)("noUpcomingBatches.svg"),
    title: "No batches and trial classes",
    description: "This educator doesn\u2019t have any batch and trial classes right now"
};
var emptyUpcomingStateConfig = {
    image: (0,_utils_imageHelper__WEBPACK_IMPORTED_MODULE_2__/* .getImage */ .gJ)("noUpcomingBatches.svg"),
    title: "No upcoming batches",
    description: "Upcoming batches will show up here"
};
var EmptyStateContainer = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("div", {
    target: "e1m47x5z0",
    label: "EmptyStateContainer"
})("grid-column-gap:", _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Spacings.SPACING_4B */ .t8.BM, ";grid-template-columns:repeat(18,32px);grid-column:1/19;border:", _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Spacings.SPACING_1 */ .t8.tF, " solid var(--color-divider);height:384px;display:flex;justify-content:center;flex-direction:column;align-items:center;h3{font-size:", _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Fonts.LARGE */ .F3.ln, ";}p{font-size:", _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Fonts.P2 */ .F3.P2, ";color:var(--color-text-secondary);}", _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .mediaQuery.uptoMobile */ .cy.uptoMobile, "{width:100%;height:290px;img{height:90px;width:90px;}h3{margin-top:", _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Spacings.SPACING_4B */ .t8.BM, ";margin-bottom:", _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Spacings.SPACING_2B */ .t8.Rw, ";}}");
var EmptyStateWrapper = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_EmptyState__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    target: "e1m47x5z1",
    label: "EmptyStateWrapper"
})("margin:auto ", _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Spacings.SPACING_0B */ .t8.NE, ";width:265px;");
var EmptyBatchStateWrapper = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("div", {
    target: "e1m47x5z2",
    label: "EmptyBatchStateWrapper"
})("margin-top:", _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Spacings.SPACING_10B */ .t8.FC, ";margin-bottom:", _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Spacings.SPACING_18B */ .t8.UX, ";", _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .mediaQuery.uptoMobile */ .cy.uptoMobile, "{margin-bottom:", _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Spacings.SPACING_6B */ .t8.BY, ";margin-right:", _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Spacings.SPACING_0B */ .t8.NE, ";}");
var Container = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(EmptyStateContainer, {
    target: "e1m47x5z3",
    label: "Container"
})("border-radius:", _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Spacings.SPACING_1B */ .t8.MK, ";");
var BatchGroupEmptyState = function(param) {
    var _config = param.config, config = _config === void 0 ? emptyStateConfig : _config;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(EmptyStateContainer, {
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(EmptyStateWrapper, {
            imgSrc: config.image,
            title: config.title,
            description: config.description
        })
    });
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (BatchGroupEmptyState)));
var BatchesEmptyState = function(param) {
    var _config = param.config, config = _config === void 0 ? emptyBatchStateConfigOnEducator : _config;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(EmptyBatchStateWrapper, {
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(BatchGroupEmptyState, {
            config: config
        })
    });
};
var UpcomingBatchEmptyState = function(param) {
    var _config = param.config, config = _config === void 0 ? emptyStateConfig : _config;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(Container, {
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(EmptyStateWrapper, {
            imgSrc: config.image,
            title: config.title,
            description: config.description
        })
    });
};


/***/ }),

/***/ 85081:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95934);
/* harmony import */ var _base_P1_P1__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85620);
/* harmony import */ var _base_H3_H3__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82034);
/* harmony import */ var _base_Button_Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35415);
/* harmony import */ var _utils_imageHelper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(48821);
/* harmony import */ var _styles_index__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2080);
/* harmony import */ var aquilla_icons_emptyStates_NoResults__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(21797);










var Empty = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])("div", {
    target: "ewg1k1m0",
    label: "Empty"
})("grid-column:", function(param) {
    var $gridColumn = param.$gridColumn;
    return $gridColumn;
}, ";text-align:center;margin-top:", function(param) {
    var $marginTop = param.$marginTop;
    return $marginTop;
}, ";", function(param) {
    var $rawStyles = param.$rawStyles;
    return $rawStyles;
}, "  display:flex;flex-direction:column;align-items:center;@media only screen and (max-width:", _styles_index__WEBPACK_IMPORTED_MODULE_6__/* .breakpoints.mobile */ .AV.mobile, "){grid-column:span 10;margin-top:", _styles_index__WEBPACK_IMPORTED_MODULE_6__/* .Spacings.SPACING_10B */ .t8.FC, ";}");
var NoDataTitle = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])(_base_H3_H3__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    target: "ewg1k1m1",
    label: "NoDataTitle"
})("margin-top:", _styles_index__WEBPACK_IMPORTED_MODULE_6__/* .Spacings.SPACING_6B */ .t8.BY, ";margin-bottom:", _styles_index__WEBPACK_IMPORTED_MODULE_6__/* .Spacings.SPACING_2B */ .t8.Rw, ";@media only screen and (max-width:", _styles_index__WEBPACK_IMPORTED_MODULE_6__/* .breakpoints.mobile */ .AV.mobile, "){margin-top:", _styles_index__WEBPACK_IMPORTED_MODULE_6__/* .Spacings.SPACING_2B */ .t8.Rw, ";font-size:16px;}");
var DescriptionP1 = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])(_base_P1_P1__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
    target: "ewg1k1m2",
    label: "DescriptionP1"
})("margin-bottom:", _styles_index__WEBPACK_IMPORTED_MODULE_6__/* .Spacings.SPACING_4B */ .t8.BM, ";@media only screen and (max-width:", _styles_index__WEBPACK_IMPORTED_MODULE_6__/* .breakpoints.mobile */ .AV.mobile, "){color:var(--color-text-primary);}");
var EmptyImage = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])("img", {
    target: "ewg1k1m3",
    label: "EmptyImage"
})("user-drag:none;user-select:none;@media only screen and (max-width:", _styles_index__WEBPACK_IMPORTED_MODULE_6__/* .breakpoints.mobile */ .AV.mobile, "){width:160px;height:160px;object-fit:cover;}");
var EmptyState = function(param) {
    var imgSrc = param.imgSrc, title = param.title, description = param.description, gridColumn = param.gridColumn, marginTop = param.marginTop, rawStyles = param.rawStyles, className = param.className, isCTAPresent = param.isCTAPresent, handleCTA = param.handleCTA, variantCTA = param.variantCTA, labelCTA = param.labelCTA;
    var renderCTAButton = function() {
        if (isCTAPresent) {
            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_base_Button_Button__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                grid: 3,
                variant: variantCTA,
                label: labelCTA,
                onClick: handleCTA,
                color: "blue"
            });
        }
    };
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)(Empty, {
        $gridColumn: gridColumn,
        $marginTop: marginTop,
        $rawStyles: rawStyles,
        className: className,
        children: [
            imgSrc ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(EmptyImage, {
                src: imgSrc,
                alt: "No data"
            }) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(aquilla_icons_emptyStates_NoResults__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
                height: _styles_index__WEBPACK_IMPORTED_MODULE_6__/* .Spacings.SPACING_30B */ .t8.hg,
                width: _styles_index__WEBPACK_IMPORTED_MODULE_6__/* .Spacings.SPACING_30B */ .t8.hg
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(NoDataTitle, {
                color: "var(--color-text-primary)",
                children: title
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(DescriptionP1, {
                color: "var(--color-text-secondary)",
                children: description
            }),
            renderCTAButton()
        ]
    });
};
EmptyState.propTypes = {
    imgSrc: (prop_types__WEBPACK_IMPORTED_MODULE_9___default().string),
    title: (prop_types__WEBPACK_IMPORTED_MODULE_9___default().string.isRequired),
    description: (prop_types__WEBPACK_IMPORTED_MODULE_9___default().string),
    gridColumn: (prop_types__WEBPACK_IMPORTED_MODULE_9___default().string),
    marginTop: (prop_types__WEBPACK_IMPORTED_MODULE_9___default().string),
    rawStyles: (prop_types__WEBPACK_IMPORTED_MODULE_9___default().string),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_9___default().string),
    isCTAPresent: (prop_types__WEBPACK_IMPORTED_MODULE_9___default().bool),
    handleCTA: (prop_types__WEBPACK_IMPORTED_MODULE_9___default().func),
    variantCTA: (prop_types__WEBPACK_IMPORTED_MODULE_9___default().string),
    labelCTA: (prop_types__WEBPACK_IMPORTED_MODULE_9___default().string)
};
EmptyState.defaultProps = {
    imgSrc: (0,_utils_imageHelper__WEBPACK_IMPORTED_MODULE_5__/* .getImage */ .gJ)("empty.svg"),
    gridColumn: "7/14",
    marginTop: _styles_index__WEBPACK_IMPORTED_MODULE_6__/* .Spacings.SPACING_21B */ .t8.R9,
    rawStyles: "",
    className: "",
    isCTAPresent: false,
    handleCTA: function() {},
    variantCTA: "",
    labelCTA: "",
    description: ""
};
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.memo)(EmptyState));


/***/ }),

/***/ 27300:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35944);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52420);
/* harmony import */ var src_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89374);
/* harmony import */ var _context_IsPageInReduxContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9716);




var PageReduxProvider = function(param) {
    var children = param.children, initialReduxState = param.initialReduxState;
    var store = (0,src_redux__WEBPACK_IMPORTED_MODULE_1__/* .getStore */ .b)(initialReduxState);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_context_IsPageInReduxContext__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
        store: store,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(react_redux__WEBPACK_IMPORTED_MODULE_0__/* .Provider */ .zt, {
            store: store,
            children: children
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (PageReduxProvider);


/***/ }),

/***/ 95201:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35944);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95934);
/* harmony import */ var _base_P1_P1__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85620);
/* harmony import */ var _styles_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2080);
/* harmony import */ var _base_Image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(80867);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _stores_useDarkModeStatus__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3458);
/* harmony import */ var _stores_selectors_darkModeStatusSelectors__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(57054);








var InfoRow = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("div", {
    target: "e1ua4qxk0",
    label: "InfoRow"
})("display:flex;margin-bottom:", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .Spacings.SPACING_3B */ .t8.N, ";width:100%;:last-child{margin-bottom:", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .Spacings.SPACING_0B */ .t8.NE, ";}");
var IconWrap = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("div", {
    target: "e1ua4qxk1",
    label: "IconWrap"
})("display:flex;align-items:flex-start;margin-right:", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .Spacings.SPACING_2B */ .t8.Rw, ";");
var StyledP1 = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_base_P1_P1__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
    target: "e1ua4qxk2",
    label: "StyledP1"
})("width:inherit;", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .mediaQuery.uptoTablet */ .cy.uptoTablet, "{font-size:", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .Fonts.P2 */ .F3.P2, ";line-height:", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .Spacings.SPACING_5B */ .t8.zj, ";}");
var BatchGroupCardInfo = function(param) {
    var batch = param.batch, showDifferentIconOnDarkMode = param.showDifferentIconOnDarkMode, height = param.height, width = param.width;
    var batchGroupMetaInfo = batch.batchGroupMetaInfo;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(BatchInfoList, {
        showDifferentIconOnDarkMode: showDifferentIconOnDarkMode,
        batchGroupInfo: batchGroupMetaInfo,
        height: height,
        width: width
    });
};
var BatchInfoList = function(param) {
    var batchGroupInfo = param.batchGroupInfo, showDifferentIconOnDarkMode = param.showDifferentIconOnDarkMode, height = param.height, width = param.width;
    var isDarkModeOn = (0,_stores_useDarkModeStatus__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_stores_selectors_darkModeStatusSelectors__WEBPACK_IMPORTED_MODULE_6__/* .getIsDarkModeOn */ .q1);
    if (!(batchGroupInfo === null || batchGroupInfo === void 0 ? void 0 : batchGroupInfo.length)) return null;
    return batchGroupInfo.map(function(info) {
        var darkModeIcon = (info === null || info === void 0 ? void 0 : info.darkmode_icon) || (info === null || info === void 0 ? void 0 : info.darkmodeIcon);
        var infoIcon = isDarkModeOn && showDifferentIconOnDarkMode ? darkModeIcon : info === null || info === void 0 ? void 0 : info.icon;
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(InfoRow, {
            children: [
                infoIcon && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(IconWrap, {
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_base_Image__WEBPACK_IMPORTED_MODULE_3__["default"], {
                        height: height,
                        width: width,
                        alt: "icon",
                        src: infoIcon
                    })
                }),
                (info === null || info === void 0 ? void 0 : info.text) && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(StyledP1, {
                    children: info.text
                })
            ]
        }, info === null || info === void 0 ? void 0 : info.text);
    });
};
BatchGroupCardInfo.propTypes = {
    batch: prop_types__WEBPACK_IMPORTED_MODULE_7___default().objectOf((prop_types__WEBPACK_IMPORTED_MODULE_7___default().any)).isRequired,
    showDifferentIconOnDarkMode: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().bool),
    height: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().number),
    width: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().number)
};
BatchGroupCardInfo.defaultProps = {
    showDifferentIconOnDarkMode: false,
    height: 20,
    width: 20
};
/* harmony default export */ __webpack_exports__["Z"] = (BatchGroupCardInfo);


/***/ }),

/***/ 35202:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35944);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95934);
/* harmony import */ var _base_Tags_Tags__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52236);
/* harmony import */ var _styles_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2080);




var StyledTag = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_base_Tags_Tags__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
    target: "e1uuqzbx0",
    label: "StyledTag"
})("width:fit-content;transition:all 300ms ease;margin:", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .Spacings.SPACING_0B */ .t8.NE, " ", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .Spacings.SPACING_2B */ .t8.Rw, " ", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .Spacings.SPACING_2B */ .t8.Rw, " ", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .Spacings.SPACING_0B */ .t8.NE, ";border:", function(param) {
    var $hasBorder = param.$hasBorder;
    return $hasBorder ? "".concat(_styles_index__WEBPACK_IMPORTED_MODULE_2__/* .Spacings.SPACING_1 */ .t8.tF, " solid var(--color-divider)}") : _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .Spacings.SPACING_0B */ .t8.NE;
}, ";");
var Container = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("div", {
    target: "e1uuqzbx1",
    label: "Container"
})();
var BatchGroupTags = function(param) {
    var _languages = param.languages, languages = _languages === void 0 ? [] : _languages, classType = param.classType, hasBorder = param.hasBorder, tagsBGColor = param.tagsBGColor;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)(Container, {
        children: [
            languages.map(function(language) {
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(StyledTag, {
                    $hasBorder: hasBorder,
                    bgColor: tagsBGColor,
                    type: "hollow",
                    children: language.label
                }, language.label);
            }),
            (classType === null || classType === void 0 ? void 0 : classType.text) && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(StyledTag, {
                $hasBorder: hasBorder,
                bgColor: tagsBGColor,
                type: "hollow",
                children: classType.text
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BatchGroupTags);


/***/ }),

/***/ 65840:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$3": function() { return /* binding */ getIsMenuHide; },
/* harmony export */   "Gj": function() { return /* binding */ getBatchTypeByFilterOptions; },
/* harmony export */   "Ph": function() { return /* binding */ getJoinBatchLabel; },
/* harmony export */   "RF": function() { return /* binding */ getMessageWithDate; },
/* harmony export */   "Y3": function() { return /* binding */ getSlashPriceMessage; },
/* harmony export */   "Yw": function() { return /* binding */ getDarkModeImage; },
/* harmony export */   "a5": function() { return /* binding */ getActiveStatus; },
/* harmony export */   "aw": function() { return /* binding */ getIsBatchCompleted; },
/* harmony export */   "d": function() { return /* binding */ getFontSizeForPrice; },
/* harmony export */   "ec": function() { return /* binding */ getInfoStringForBatchGroup; },
/* harmony export */   "gP": function() { return /* binding */ getCtaState; },
/* harmony export */   "hw": function() { return /* binding */ getTagsConfig; },
/* harmony export */   "qC": function() { return /* binding */ getIsBatchAccessEnded; },
/* harmony export */   "ri": function() { return /* binding */ getEntitySubType; },
/* harmony export */   "u": function() { return /* binding */ getBatchConfig; },
/* harmony export */   "wR": function() { return /* binding */ getIsEnrollmentClosed; },
/* harmony export */   "wS": function() { return /* binding */ getHref; },
/* harmony export */   "x1": function() { return /* binding */ getBusinessPlatform; },
/* harmony export */   "yE": function() { return /* binding */ getShowFeedback; },
/* harmony export */   "ym": function() { return /* binding */ getTabRefs; },
/* harmony export */   "yu": function() { return /* binding */ getLanguagesForCard; }
/* harmony export */ });
/* unused harmony exports getEnrollmentEndMessage, getCardSpecificDetail, getEnrollmentStatusIcon, getCharCount */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(10253);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(29815);
/* harmony import */ var _models_Item__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46571);
/* harmony import */ var _styles_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2080);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47426);
/* harmony import */ var _utils_dates__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97428);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10736);











var enrollmentClockIcon = "prodigy/enrollment-clock.svg";
var enrollmentEndedIcons = "prodigy/enrollment-end.svg";
var getMessageWithDate = function() {
    var startingText = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", date = arguments.length > 1 ? arguments[1] : void 0;
    if (!date) return null;
    var dateShort = (0,_utils_dates__WEBPACK_IMPORTED_MODULE_3__/* .getDateMonthString */ .$s)(date, false, false);
    var year = (0,_utils_dates__WEBPACK_IMPORTED_MODULE_3__/* .getYear */ .So)(date);
    return "".concat(startingText, " ").concat(dateShort, " ").concat(year);
};
var getIsEnrollmentClosed = function(enrollmentEndDate) {
    if (!enrollmentEndDate) return false;
    var dateDifference = (0,_utils_dates__WEBPACK_IMPORTED_MODULE_3__/* .getDateDifference */ .hM)(enrollmentEndDate);
    return dateDifference <= 0;
};
var getIsBatchCompleted = function(batchEndDate) {
    if (!batchEndDate) return false;
    var dateDifference = (0,_utils_dates__WEBPACK_IMPORTED_MODULE_3__/* .getDateDifference */ .hM)(batchEndDate);
    return dateDifference <= 0;
};
var getIsBatchAccessEnded = function(batchAccessEndDate) {
    if (!batchAccessEndDate) return false;
    var dateDifference = (0,_utils_dates__WEBPACK_IMPORTED_MODULE_3__/* .getDateDifference */ .hM)(batchAccessEndDate);
    return dateDifference <= 0;
};
// TODO  need to handle for PLATINUM BATCH GROUP
var getBusinessPlatform = function(goalData) {
    if (goalData === null || goalData === void 0 ? void 0 : goalData.isPlatformGoal) return _utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .businessPlatform.UA_PLATFORM */ .Kr.UA_PLATFORM;
    return _utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .businessPlatform.UNACADEMY */ .Kr.UNACADEMY;
};
var getSlashPriceMessage = function(date, promoText, isDiscountAvailable) {
    if (!date || !isDiscountAvailable) return "";
    var relativeDate = (0,_utils_dates__WEBPACK_IMPORTED_MODULE_3__/* .getRelativeDayOrCurrentDateWithTDays */ .Aw)(date, true);
    var isRelativeDateTodayTomorrow = _utils_dates__WEBPACK_IMPORTED_MODULE_3__/* .todayTomorrowConfig.some */ .Wb.some(function(day) {
        return day === relativeDate;
    });
    if (isRelativeDateTodayTomorrow) {
        return promoText || "Discount ends ".concat(relativeDate);
    }
    if (relativeDate <= 7) {
        return promoText || "Discount ends in ".concat(relativeDate, " days");
    }
    return "";
};
var getEnrollmentEndMessage = function(date) {
    if (!date) return "N/A";
    var relativeDate = getRelativeDayOrCurrentDateWithTDays(date, true);
    var isRelativeDateTodayTomorrow = todayTomorrowConfig.some(function(day) {
        return day === relativeDate;
    });
    if (!relativeDate) {
        return "Enrollments have closed for this batch";
    }
    if (isRelativeDateTodayTomorrow) {
        return "Enrollment ends ".concat(relativeDate);
    }
    if (relativeDate <= 7 && relativeDate > 0) {
        return "Enrollment ends in ".concat(relativeDate, " days");
    }
    return "Enrollment ends on ".concat(relativeDate);
};
var getEnrollmentStatusIcon = function(date) {
    if (!date) return "";
    var relativeDate = getRelativeDayOrCurrentDateWithTDays(date, true);
    return relativeDate < 0 ? enrollmentEndedIcons : enrollmentClockIcon;
};
var getCardSpecificDetail = function(enrollmentEndDate, trialClasses) {
    var hasTrailClass = !isEmpty(trialClasses);
    var defaultObject = {
        buttonColor: "var(--color-red-border-focus)",
        textColor: "var(--color-i-red)",
        icon: enrollmentClockIcon
    };
    var isEnrollmentClose = getIsEnrollmentClosed(enrollmentEndDate);
    if (isEnrollmentClose) {
        return _object_spread_props(_object_spread({}, defaultObject), {
            buttonText: "Enrolment closed",
            icon: "calendar-clock.svg",
            buttonColor: "var(--color-base-light-0)",
            textColor: "var(--color-text-secondary)"
        });
    }
    var remainingDaysCount = getDateDifference(enrollmentEndDate);
    // we will only show enroll text if the date difference is <= 7 or it does not has trail classes.
    var showEnrollMessage = remainingDaysCount <= 7 || !hasTrailClass;
    if (showEnrollMessage) {
        return _object_spread_props(_object_spread({}, defaultObject), {
            buttonText: getEnrollmentEndMessage(enrollmentEndDate)
        });
    }
    return _object_spread_props(_object_spread({}, defaultObject), {
        buttonText: (trialClasses === null || trialClasses === void 0 ? void 0 : trialClasses.text) || "Check out trial classes",
        icon: "batch-play-all.svg",
        buttonColor: "var(--color-base-light-0)",
        textColor: "var(--color-text-primary)"
    });
};
var getCharCount = function() {
    var string = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    if (!string) return 0;
    return string.length;
};
var getFontSizeForPrice = function(price, listPrice, isDiscountAvailable) {
    if (!isDiscountAvailable) return _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Fonts.LARGE */ .F3.ln;
    if (getCharCount(price) > 7 || getCharCount(listPrice) > 7) {
        return _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Fonts.SMALL */ .F3.HC;
    }
    return _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Fonts.LARGE */ .F3.ln;
};
var getHref = function(href, as, isMobile) {
    var data = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : [], maximumItemNeedToShowSeeAll = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : _constants__WEBPACK_IMPORTED_MODULE_5__/* .DEFAULT_ITEM_LENGTH_FOR_SEE_ALL */ .Tx;
    var updatedHref = null;
    var updatedAs = null;
    if (isMobile && data.length > _constants__WEBPACK_IMPORTED_MODULE_5__/* .ITEM_TO_SHOW_IN_M_WEB */ .tB || data.length > maximumItemNeedToShowSeeAll) {
        updatedHref = href;
        updatedAs = as;
    }
    return {
        updatedHref: updatedHref,
        updatedAs: updatedAs
    };
};
var getBatchTypeByFilterOptions = function() {
    var filterOptions = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (!!(filterOptions === null || filterOptions === void 0 ? void 0 : filterOptions.value) && !((filterOptions === null || filterOptions === void 0 ? void 0 : filterOptions.value) in _constants__WEBPACK_IMPORTED_MODULE_5__/* .filterType */ .HT)) {
        return "";
    }
    return _constants__WEBPACK_IMPORTED_MODULE_5__/* .filterType */ .HT[filterOptions === null || filterOptions === void 0 ? void 0 : filterOptions.value];
};
var getInfoIcon = function() {
    var isDarkModeOn = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, stateMetaInfo = arguments.length > 1 ? arguments[1] : void 0;
    var darkModeIcon = (stateMetaInfo === null || stateMetaInfo === void 0 ? void 0 : stateMetaInfo.darkmode_icon) || (stateMetaInfo === null || stateMetaInfo === void 0 ? void 0 : stateMetaInfo.darkmodeIcon);
    if (isDarkModeOn && darkModeIcon) {
        return darkModeIcon;
    }
    return stateMetaInfo === null || stateMetaInfo === void 0 ? void 0 : stateMetaInfo.icon;
};
var getCtaState = function(stateMetaInfo) {
    var isDarkModeOn = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var hasCardState = !!(stateMetaInfo === null || stateMetaInfo === void 0 ? void 0 : stateMetaInfo.state);
    if (!hasCardState || !((stateMetaInfo === null || stateMetaInfo === void 0 ? void 0 : stateMetaInfo.state) in _constants__WEBPACK_IMPORTED_MODULE_5__/* .cardCtaConfig */ .Bb)) return null;
    var text = stateMetaInfo.text;
    var infoIcon = getInfoIcon(isDarkModeOn, stateMetaInfo);
    var _state = _constants__WEBPACK_IMPORTED_MODULE_5__/* .cardCtaConfig */ .Bb[stateMetaInfo.state], buttonColor = _state.buttonColor, textColor = _state.textColor;
    return {
        icon: infoIcon,
        text: text,
        buttonColor: buttonColor,
        textColor: textColor
    };
};
var getLanguagesForCard = function() {
    var languages = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    var languagesToShow = (languages === null || languages === void 0 ? void 0 : languages.length) > _constants__WEBPACK_IMPORTED_MODULE_5__/* .LANGUAGE_COUNT_FOR_CARD */ .Yv ? languages.slice(0, _constants__WEBPACK_IMPORTED_MODULE_5__/* .LANGUAGE_COUNT_FOR_CARD */ .Yv) : languages;
    return languagesToShow;
};
var getBatchConfig = function(type) {
    // it will return the default object in case type is not exist in BATCH_GROUP_TYPE_CONFIG
    if (!(type in _constants__WEBPACK_IMPORTED_MODULE_5__/* .BATCH_GROUP_TYPE_CONFIG */ .Vo)) return _constants__WEBPACK_IMPORTED_MODULE_5__/* .BATCH_GROUP_TYPE_CONFIG["default"] */ .Vo["default"];
    return _constants__WEBPACK_IMPORTED_MODULE_5__/* .BATCH_GROUP_TYPE_CONFIG */ .Vo[type];
};
var getJoinBatchLabel = function(classType) {
    if (!(classType === null || classType === void 0 ? void 0 : classType.key) || !Object.values(_constants__WEBPACK_IMPORTED_MODULE_5__/* .batchGroupType */ .rP).includes(classType === null || classType === void 0 ? void 0 : classType.key)) return "Join batch";
    if ([
        _constants__WEBPACK_IMPORTED_MODULE_5__/* .batchGroupType.LIVE */ .rP.LIVE,
        _constants__WEBPACK_IMPORTED_MODULE_5__/* .batchGroupType.LIVE_AND_RECORDED */ .rP.LIVE_AND_RECORDED
    ].includes(classType === null || classType === void 0 ? void 0 : classType.key)) return "Join batch";
    if ((classType === null || classType === void 0 ? void 0 : classType.key) === _constants__WEBPACK_IMPORTED_MODULE_5__/* .batchGroupType.RECORDED */ .rP.RECORDED) return "Buy now";
};
var getEntitySubType = function(classType) {
    if (!(classType === null || classType === void 0 ? void 0 : classType.key) || !((classType === null || classType === void 0 ? void 0 : classType.key) in _constants__WEBPACK_IMPORTED_MODULE_5__/* .ENTITY_SUB_TYPE */ .lv)) {
        return "Live";
    }
    return _constants__WEBPACK_IMPORTED_MODULE_5__/* .ENTITY_SUB_TYPE */ .lv[classType === null || classType === void 0 ? void 0 : classType.key];
};
var getInfoString = function(lesson) {
    // Cancelled
    var classState = lesson === null || lesson === void 0 ? void 0 : lesson.classState;
    var classType = lesson === null || lesson === void 0 ? void 0 : lesson.classType;
    if (classState === _constants__WEBPACK_IMPORTED_MODULE_5__/* .CLASS_STATE.CANCELLED_STATE */ .gy.CANCELLED_STATE) {
        return "Cancelled";
    }
    if (classState === _constants__WEBPACK_IMPORTED_MODULE_5__/* .CLASS_STATE.LIVE_STATE */ .gy.LIVE_STATE) {
        return "Started at ".concat((0,_utils_dates__WEBPACK_IMPORTED_MODULE_3__/* .formatTime */ .mr)(lesson.startedAt || lesson.liveAt));
    }
    // isRescheduled
    if (classState === _constants__WEBPACK_IMPORTED_MODULE_5__/* .CLASS_STATE.RESCHEDULED_STATE */ .gy.RESCHEDULED_STATE) {
        return "Rescheduled to ".concat((0,_utils_dates__WEBPACK_IMPORTED_MODULE_3__/* .getDateMonthString */ .$s)(lesson.startedAt || lesson.liveAt, false, false), ", ").concat((0,_utils_dates__WEBPACK_IMPORTED_MODULE_3__/* .getTime */ .hK)(lesson.startedAt || lesson.liveAt));
    }
    // RECORDED Batch
    if (classType === _constants__WEBPACK_IMPORTED_MODULE_5__/* .batchGroupType.RECORDED */ .rP.RECORDED) {
        // RECORDED Batch + completely watched
        if (classState === _constants__WEBPACK_IMPORTED_MODULE_5__/* .CLASS_STATE.COMPLETELY_WATCHED_STATE */ .gy.COMPLETELY_WATCHED_STATE) return "Completed".concat(_constants__WEBPACK_IMPORTED_MODULE_5__/* .SPACE_WITH_DOT */ .aG).concat((0,_utils_dates__WEBPACK_IMPORTED_MODULE_3__/* .getHoursMinutesValueFromSeconds */ .mU)(lesson === null || lesson === void 0 ? void 0 : lesson.lessonDuration));
        return "".concat((0,_utils_dates__WEBPACK_IMPORTED_MODULE_3__/* .getHoursMinutesValueFromSeconds */ .mU)(lesson === null || lesson === void 0 ? void 0 : lesson.lessonDuration));
    }
    if (classState === _constants__WEBPACK_IMPORTED_MODULE_5__/* .CLASS_STATE.COMPLETELY_WATCHED_STATE */ .gy.COMPLETELY_WATCHED_STATE) {
        return "Completed".concat(_constants__WEBPACK_IMPORTED_MODULE_5__/* .SPACE_WITH_DOT */ .aG, "Ended on ").concat((0,_utils_dates__WEBPACK_IMPORTED_MODULE_3__/* .getDateMonthString */ .$s)(lesson === null || lesson === void 0 ? void 0 : lesson.endsAt, false, false));
    }
    if (classState === _constants__WEBPACK_IMPORTED_MODULE_5__/* .CLASS_STATE.NOT_WATCHED_STATE */ .gy.NOT_WATCHED_STATE) {
        return "".concat("Missed ".concat(_constants__WEBPACK_IMPORTED_MODULE_5__/* .SPACE_WITH_DOT */ .aG), "Ended on ").concat((0,_utils_dates__WEBPACK_IMPORTED_MODULE_3__/* .getDateMonthString */ .$s)(lesson === null || lesson === void 0 ? void 0 : lesson.endsAt, false, false));
    }
    // live batch Continue Watching
    if (classState === _constants__WEBPACK_IMPORTED_MODULE_5__/* .CLASS_STATE.CONTINUE_WATCH_STATE */ .gy.CONTINUE_WATCH_STATE) {
        return "Ended on ".concat((0,_utils_dates__WEBPACK_IMPORTED_MODULE_3__/* .getDateMonthString */ .$s)(lesson === null || lesson === void 0 ? void 0 : lesson.endsAt, false, false));
    }
    // upcoming
    return "".concat((0,_utils_dates__WEBPACK_IMPORTED_MODULE_3__/* .formatTime */ .mr)(lesson.liveAt));
};
var getInfoStringForBatchGroup = function(lesson) {
    var batchGroupInfoString = getInfoString(lesson);
    return "".concat(batchGroupInfoString).concat(_constants__WEBPACK_IMPORTED_MODULE_5__/* .SPACE_WITH_DOT */ .aG).concat((0,_models_Item__WEBPACK_IMPORTED_MODULE_0__/* .getPersonName */ .rQ)(lesson === null || lesson === void 0 ? void 0 : lesson.author));
};
var getIsMenuHide = function(lesson) {
    return !((lesson === null || lesson === void 0 ? void 0 : lesson.classState) === _constants__WEBPACK_IMPORTED_MODULE_5__/* .CLASS_STATE.LIVE_STATE */ .gy.LIVE_STATE);
};
var getTagsConfig = function() {
    var isEnrolled = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    if (!isEnrolled) {
        var tabConfig = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, _constants__WEBPACK_IMPORTED_MODULE_5__/* .defaultTabsConfig */ .MP);
        delete tabConfig[_constants__WEBPACK_IMPORTED_MODULE_5__/* .Sections.ABOUT */ .bx.ABOUT];
        return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, _constants__WEBPACK_IMPORTED_MODULE_5__/* .Sections.ABOUT */ .bx.ABOUT, {
            label: _constants__WEBPACK_IMPORTED_MODULE_5__/* .tabLabel.ABOUT */ .Jg.ABOUT,
            key: _constants__WEBPACK_IMPORTED_MODULE_5__/* .Sections.ABOUT */ .bx.ABOUT,
            id: 2,
            value: 2
        }), tabConfig);
    }
    return _constants__WEBPACK_IMPORTED_MODULE_5__/* .defaultTabsConfig */ .MP;
};
var getDarkModeImage = function() {
    var isDarkModeOn = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, darkModeImage = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", image = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
    if (isDarkModeOn && darkModeImage) {
        return darkModeImage;
    }
    return image;
};
var getShowFeedback = function() {
    var batchDetails = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var ref;
    var ref1;
    var isEnrolled = (ref1 = batchDetails === null || batchDetails === void 0 ? void 0 : batchDetails.isEnrolled) !== null && ref1 !== void 0 ? ref1 : false;
    var ref2;
    var isCardAvailable = (ref2 = batchDetails === null || batchDetails === void 0 ? void 0 : (ref = batchDetails.feedbackData) === null || ref === void 0 ? void 0 : ref.is_card_available) !== null && ref2 !== void 0 ? ref2 : false;
    // we will show feedback card when learner is enrolled and have is_card_available key as true.
    return isEnrolled && isCardAvailable;
};
var getTabRefs = function() {
    var isEnrolled = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, ref = arguments.length > 1 ? arguments[1] : void 0, scheduleRef = ref.scheduleRef, lessonRef = ref.lessonRef, aboutRef = ref.aboutRef, educatorRef = ref.educatorRef, faqsRef = ref.faqsRef;
    var defaultOrderOfTabs = [
        {
            ref: scheduleRef,
            shrinkPos: _utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .scrollConstants.scroll100 */ .CU.scroll100,
            id: _constants__WEBPACK_IMPORTED_MODULE_5__/* .Sections.BATCH_SCHEDULE */ .bx.BATCH_SCHEDULE
        },
        {
            ref: lessonRef,
            shrinkPos: _utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .scrollConstants.scroll100 */ .CU.scroll100,
            id: _constants__WEBPACK_IMPORTED_MODULE_5__/* .Sections.LESSONS */ .bx.LESSONS
        },
        {
            ref: educatorRef,
            shrinkPos: _utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .scrollConstants.scroll100 */ .CU.scroll100,
            id: _constants__WEBPACK_IMPORTED_MODULE_5__/* .Sections.EDUCATORS */ .bx.EDUCATORS
        },
        {
            ref: aboutRef,
            shrinkPos: _utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .scrollConstants.scroll100 */ .CU.scroll100,
            id: _constants__WEBPACK_IMPORTED_MODULE_5__/* .Sections.ABOUT */ .bx.ABOUT
        },
        {
            ref: faqsRef,
            shrinkPos: _utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .scrollConstants.scroll280 */ .CU.scroll280,
            id: _constants__WEBPACK_IMPORTED_MODULE_5__/* .Sections.FAQS */ .bx.FAQS
        }
    ];
    if (!isEnrolled) {
        // here we are updating the tabs order moving ABOUT section on top
        var filteredTabs = defaultOrderOfTabs.filter(function(tabObject) {
            return tabObject.id !== _constants__WEBPACK_IMPORTED_MODULE_5__/* .Sections.ABOUT */ .bx.ABOUT;
        });
        return [
            {
                ref: aboutRef,
                shrinkPos: _utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .scrollConstants.scroll100 */ .CU.scroll100,
                id: _constants__WEBPACK_IMPORTED_MODULE_5__/* .Sections.ABOUT */ .bx.ABOUT
            }
        ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(filteredTabs));
    }
    return defaultOrderOfTabs;
};
// we are updating the tab ordering in case of enrolled user
// order of tabRefs should be same with activeStatuses
var getActiveStatus = function(isEnrolled, activeStatuses) {
    var _activeStatuses = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(activeStatuses, 5), isAboutSectionActive = _activeStatuses[0], isScheduleSectionActive = _activeStatuses[1], isLessonSectionActive = _activeStatuses[2], isEducatorSectionActive = _activeStatuses[3], isFAQsSectionActive = _activeStatuses[4];
    if (isEnrolled) {
        var ref;
        ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(activeStatuses, 5), isScheduleSectionActive = ref[0], isLessonSectionActive = ref[1], isEducatorSectionActive = ref[2], isAboutSectionActive = ref[3], isFAQsSectionActive = ref[4], ref;
    }
    return {
        isAboutSectionActive: isAboutSectionActive,
        isScheduleSectionActive: isScheduleSectionActive,
        isLessonSectionActive: isLessonSectionActive,
        isEducatorSectionActive: isEducatorSectionActive,
        isFAQsSectionActive: isFAQsSectionActive
    };
};



/***/ }),

/***/ 60722:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(26042);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils_textHelper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31309);
/* harmony import */ var _models_Me__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92942);
/* harmony import */ var _utils_dates__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97428);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(43135);
/* harmony import */ var _hooks_usePlatformInfo__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(79592);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(41609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _api_selectors_auth__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(73060);
/* harmony import */ var _api_hooks_auth_useMyInfo__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85780);
/* harmony import */ var _api_selectors_subscription__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(58063);
/* harmony import */ var _stores_selectors_login__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(98964);
/* harmony import */ var _stores_login_loginStore__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(44545);













var getBatchState = function(startDate, completedDate) {
    if (!startDate || !completedDate) return "NA";
    var currentDate = new Date();
    var d1 = new Date(startDate);
    var d2 = new Date(completedDate);
    if (currentDate < d1) return "Upcoming";
    if (currentDate > d2) return "Finished";
    return "Ongoing";
};
var usePlatformEventProps = function(param) {
    var _batch = param.batch, batch = _batch === void 0 ? {} : _batch, _isBatch = param.isBatch, isBatch = _isBatch === void 0 ? false : _isBatch, _entityContentType = param.entityContentType, entityContentType = _entityContentType === void 0 ? false : _entityContentType, _lastPrimarySourceSection = param.lastPrimarySourceSection, lastPrimarySourceSection = _lastPrimarySourceSection === void 0 ? "NA" : _lastPrimarySourceSection, _lastPrimarySource = param.lastPrimarySource, lastPrimarySource = _lastPrimarySource === void 0 ? null : _lastPrimarySource, _extraProps = param.extraProps, extraProps = _extraProps === void 0 ? {} : _extraProps, _isPurchaseType = param.isPurchaseType, isPurchaseType = _isPurchaseType === void 0 ? false : _isPurchaseType, _isSlashedPriceType = param.isSlashedPriceType, isSlashedPriceType = _isSlashedPriceType === void 0 ? false : _isSlashedPriceType;
    var me = (0,_api_hooks_auth_useMyInfo__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_api_selectors_auth__WEBPACK_IMPORTED_MODULE_10__/* .getMe */ .jo);
    var isRegistered = (0,_stores_login_loginStore__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_stores_selectors_login__WEBPACK_IMPORTED_MODULE_11__/* .getIsRegistered */ .eG);
    var batchGroupSubscriptions = (0,_api_selectors_subscription__WEBPACK_IMPORTED_MODULE_8__/* .getBatchGroupSubscriptions */ .rN)(me.purchasedItems);
    var activeBatchSubscriptions = (0,_api_selectors_subscription__WEBPACK_IMPORTED_MODULE_8__/* .getTotalActiveBatches */ .b8)(me.purchasedItems);
    var batchSubscriptionActive = (0,_api_selectors_subscription__WEBPACK_IMPORTED_MODULE_8__/* .hasActiveBatch */ .k)(me.purchasedItems);
    var info = (0,_hooks_usePlatformInfo__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(batch);
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        var ref = batch || {}, startsAt = ref.startsAt, authors = ref.authors, completedAt = ref.completedAt, isEnrolled = ref.isEnrolled, languages = ref.languages, goal = ref.goal, sessions = ref.lessonsCount, enrollmentEndDate = ref.enrollmentEndDate, batchExpiryDate = ref.batchExpiryDate, trialClasses = ref.trialClasses, discountEndDate = ref.discountEndDate;
        var ref1 = goal || {}, goalUID = ref1.uid, goalName = ref1.name;
        var ref2;
        var subscription = (ref2 = (0,_models_Me__WEBPACK_IMPORTED_MODULE_2__/* .getBatchSubscriptionByBatchUID */ .z0)(batchGroupSubscriptions, batch === null || batch === void 0 ? void 0 : batch.uid)) !== null && ref2 !== void 0 ? ref2 : {};
        var _user_subscription_timeline = subscription.user_subscription_timeline, user_subscription_timeline = _user_subscription_timeline === void 0 ? [
            {}
        ] : _user_subscription_timeline;
        var ref3 = user_subscription_timeline[0] || {}, _time_remaining = ref3.time_remaining, time_remaining = _time_remaining === void 0 ? 0 : _time_remaining, _expired_at = ref3.expired_at, expired_at = _expired_at === void 0 ? 0 : _expired_at, _duration = ref3.duration, duration = _duration === void 0 ? 0 : _duration, subscription_type = ref3.subscription_type, tmp = ref3.started_at, purchasedDate = tmp === void 0 ? 0 : tmp;
        var getSubscriptionType = function(type) {
            var entries = Object.entries(_constants_index__WEBPACK_IMPORTED_MODULE_4__/* .subscriptionTypes */ .Lw);
            var subscribedType = entries.find(function(entry) {
                return entry[1] === type;
            });
            return subscribedType ? subscribedType[0] : "NA";
        };
        var is_subscription_active = time_remaining > 0;
        var hasBatchSubscription = !!subscription.user_subscription_timeline;
        // eslint-disable-next-line no-nested-ternary
        var purchaseType = hasBatchSubscription ? hasBatchSubscription.time_remaining ? "extension" : "renewal" : "new";
        var segmentData = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({
            entity_uid: batch === null || batch === void 0 ? void 0 : batch.uid,
            entity_title: batch === null || batch === void 0 ? void 0 : batch.name,
            start_date: startsAt,
            end_date: completedAt,
            batch_expiry_date: batchExpiryDate || "NA",
            educator_uid: (0,_utils_textHelper__WEBPACK_IMPORTED_MODULE_1__/* .getCommaSeparatedUIDs */ .$V)(authors) || "NA",
            educator_uid_list: (0,_utils_textHelper__WEBPACK_IMPORTED_MODULE_1__/* .getCommaSeparatedUIDs */ .$V)(authors) || "NA",
            educator_name: (0,_utils_textHelper__WEBPACK_IMPORTED_MODULE_1__/* .getCommaSeparatedUIDs */ .$V)(authors, "name") || "NA",
            educator_username: (0,_utils_textHelper__WEBPACK_IMPORTED_MODULE_1__/* .getCommaSeparatedUIDs */ .$V)(authors, "username") || "NA",
            educator_username_list: (0,_utils_textHelper__WEBPACK_IMPORTED_MODULE_1__/* .getCommaSeparatedUIDs */ .$V)(authors, "username") || "NA",
            educator_name_list: (0,_utils_textHelper__WEBPACK_IMPORTED_MODULE_1__/* .getCommaSeparatedUIDs */ .$V)(authors, "name") || "NA",
            number_of_sessions: sessions || "NA",
            days_till_batch_end: (0,_utils_dates__WEBPACK_IMPORTED_MODULE_3__/* .getRelativeDays */ .MK)(true, completedAt),
            days_till_enrollment_end: (0,_utils_dates__WEBPACK_IMPORTED_MODULE_3__/* .getRelativeDays */ .MK)(true, enrollmentEndDate),
            number_of_active_batch_subscription: activeBatchSubscriptions,
            is_enrolled: isEnrolled || false,
            purchase_enrollment_end_datediff: (0,_utils_dates__WEBPACK_IMPORTED_MODULE_3__/* .getRelativeDays */ .MK)(false, enrollmentEndDate, purchasedDate),
            language: (0,_utils_textHelper__WEBPACK_IMPORTED_MODULE_1__/* .getCommaSeparatedUIDs */ .$V)(languages, "label") || "NA",
            goal_name: goalName,
            goal_uid: goalUID,
            is_subscription_active: is_subscription_active,
            is_batch_subscription_active: batchSubscriptionActive,
            last_primary_source_section: lastPrimarySourceSection,
            subscription_duration: duration || "NA",
            subscription_end_date: expired_at || "NA",
            user_subscription_type: getSubscriptionType(subscription_type),
            has_trial_classes: !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_6___default()(trialClasses),
            is_new_user: !isRegistered,
            is_upgrade: "NA"
        }, extraProps);
        if (isBatch) {
            segmentData.subscription_price = (batch === null || batch === void 0 ? void 0 : batch.price) || "NA";
            segmentData.batch_title = batch === null || batch === void 0 ? void 0 : batch.name;
            segmentData.batch_state = getBatchState(startsAt, completedAt);
            segmentData.batch_uid = batch === null || batch === void 0 ? void 0 : batch.batchUID;
        }
        if (entityContentType) {
            segmentData.entity_content_type = info === null || info === void 0 ? void 0 : info.entityContentType;
        }
        if (isPurchaseType) {
            segmentData.purchase_type = purchaseType;
        }
        if (lastPrimarySource) {
            segmentData.last_primary_source = lastPrimarySource;
        }
        if (isSlashedPriceType) {
            var ref4;
            segmentData.is_price_slashed = (ref4 = batch === null || batch === void 0 ? void 0 : batch.isDiscountAvailable) !== null && ref4 !== void 0 ? ref4 : false;
            segmentData.num_days_to_price_increase = (0,_utils_dates__WEBPACK_IMPORTED_MODULE_3__/* .getRelativeDays */ .MK)(true, discountEndDate);
            segmentData.listing_price = (batch === null || batch === void 0 ? void 0 : batch.listPrice) || "NA";
        }
        return segmentData;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        batch,
        batchSubscriptionActive
    ]);
};
/* harmony default export */ __webpack_exports__["Z"] = (usePlatformEventProps);


/***/ })

}]);